<template>
  <v-card title="部门维护">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="8">
            <div style="text-align: left">
              <v-form-item>
                <v-button type="success" icon="plus" @click="add('')"
                  ><span>添加</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="16">
            <div style="text-align: right">
              <v-form-item>
                <v-input
                  placeholder="输入部门名称"
                  v-model="cx"
                ></v-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            &nbsp;&nbsp;
            
            <v-popconfirm
              title="是否确认删除数据，删除后数据无法恢复！"
              @confirm="del(row)"
              @cancel="cancel"
              placement="bottomRight"
            >
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      cx: "",
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 500,
        headerAlign: "center",
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
           {
            field: "bmbm",
            title: "部门编码",
            align: "center",
          },
          {
            field: "bmmc",
            title: "部门名称",
            align: "center",
          },
          
          {
            field: "lrry",
            title: "录入人员",
            align: "center",
          },
          {
            field: "lrsj",
            title: "录入日期",
            align: "center",
          },
          {
            field: "xgry",
            title: "修改人员",
            align: "center",
          },
          {
            field: "xgsj",
            title: "修改日期",
            align: "center",
          },
         
          {
            field: "xybz",
            title: "状态",
            align: "center",
            slots: {
              default: ({ row, column }) => {
                let xy_bz = row.xybz == '1' ? "启用" : "禁用";
                return [<span>{xy_bz}</span>];
              },
            },
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz",
            },
          },
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.$axios.get("api/system/qxgl/get-sysbm-list?cx=" + this.cx).then((res) => {
         
        this.tableData = res.data;
      });
    },
    add: function (row) {
      let id = row == "" ? "" : row.id;
      let title = row == "" ? "添加部门" : "修改部门";
      xadmin.open(title, "/sysbmadd?id=" + id, "800", "300","",this.findList);
    },
    del: function (row) {
      this.$axios
        .get("api/system/qxgl/del-sysbm?id=" + row.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    cancel: function () {
      this.$message.info("取消删除");
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/yhgl/sysbm.vue